import { Dc_Text_Blockquote } from "@op/sf-op";
import type { BlockquoteProps } from "@op/puck-types";

const Blockquote = ({ children, subtitle }: BlockquoteProps) => {
  return (
    <Dc_Text_Blockquote text={children}>
      {subtitle && (
        <Dc_Text_Blockquote.Subtitle>{subtitle}</Dc_Text_Blockquote.Subtitle>
      )}
    </Dc_Text_Blockquote>
  );
};

export default Blockquote;
